<template>
  <div class="outer-wrapper">
    <div>
      <div
        class="md-layout md-alignment-middle-left booking-discount"
        style="margin-top: 1em; align-items:center;"
      >
        <div class="md-layout-item md-size-90" style="margin-top: 1em;">
          <h6 style="margin-bottom:0;">Discount</h6>
        </div>
        <div
          class="md-layout-item md-size-10 text-right"
          style="margin-top: 1em;"
        >
          <md-button
            class="md-icon-button md-dense md-primary md-round"
            @click="showDialog"
          >
            <md-icon>add</md-icon>
          </md-button>
        </div>
      </div>

      <div
        v-for="discountCode in selectedDiscounts"
        :key="discountCode.id"
        class="md-layout md-alignment-middle-left discount-code"
      >
        <div class="md-layout-item md-size-90">
          {{ discountCode.description }}
        </div>
        <div class="md-layout-item md-size-10 text-right">
          <md-button
            class="md-icon-button md-dense md-danger md-simple"
            @click.stop="removeDiscount(discountCode)"
          >
            <md-icon>clear</md-icon>
            <md-tooltip md-direction="top">Remove this Discount</md-tooltip>
          </md-button>
        </div>
      </div>
    </div>

    <md-dialog :md-active.sync="showDiscountDialog">
      <md-dialog-title>Discounts</md-dialog-title>
      <div class="md-layout">
        <md-table
          class="md-layout-item md-size-100"
          v-model="availableDiscounts"
          md-card
          @md-selected="onSelect"
        >
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            md-selectable="single"
          >
            <md-table-cell md-label="Code">{{ item.code }}</md-table-cell>
            <md-table-cell md-label="Description">{{
              item.description
            }}</md-table-cell>
          </md-table-row>
        </md-table>
      </div>
      <md-dialog-actions>
        <md-button
          class="md-primary md-dense"
          @click="showDiscountDialog = false"
          >Cancel</md-button
        >
        <md-button
          class="md-primary md-dense"
          @click="addDiscount"
          :disabled="!selectedDiscount"
          >Apply</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import confirm from "@/helpers/deleteConfirm";
import bookingApi from "@/services/api/booking";
import discountApi from "@/services/api/discount";
import { notifyError, notifySuccess } from "@/helpers/notify";
import _filter from "lodash/filter";

export default {
  name: "BookingDiscount",

  props: ["booking"],

  data() {
    return {
      discounts: [],
      showDiscountDialog: false,
      selectedDiscount: null,
      selectedDiscounts: this.booking?.discount_codes || []
    };
  },

  computed: {
    availableDiscounts() {
      let exisitingDiscounts = this.selectedDiscounts.map(dc => dc.id);
      return _filter(this.discounts, function(discount) {
        return !exisitingDiscounts.includes(discount.id);
      });
    }
  },

  methods: {
    getSuccessMessage(response, fallback) {
      return response?.message || response?.data?.message || fallback;
    },

    getErrorMessage(error, fallback) {
      return error?.response?.data?.message ?? fallback;
    },

    updated() {
      this.$emit("updated");
    },

    showDialog() {
      this.selectedDiscount = null;
      this.showDiscountDialog = true;
    },

    getDiscounts() {
      discountApi.getAvailableDiscounts(this.booking).then(response => {
        this.discounts = response?.data?.discount_codes;
      });
    },

    async addDiscount() {
      this.showDiscountDialog = false;

      try {
        const response = await bookingApi.addDiscount(
          this.booking,
          this.selectedDiscount
        );

        let discountCode = response.data.discount_code;
        this.selectedDiscounts.push(discountCode);

        notifySuccess(
          this,
          this.getSuccessMessage(response, "Discount applied.")
        );

        this.updated();
      } catch (error) {
        notifyError(
          this,
          this.getErrorMessage(error, "Unable to apply discount.")
        );
      }
    },

    removeDiscount(discountCode) {
      confirm.delete(null).then(async resp => {
        if (resp.value) {
          try {
            const response = await bookingApi.removeDiscount(
              this.booking,
              discountCode
            );

            this.selectedDiscounts = _filter(
              this.selectedDiscounts,
              el => el.id !== discountCode.id
            );

            notifySuccess(
              this,
              this.getSuccessMessage(response, "Discount removed.")
            );

            this.updated();
          } catch (error) {
            notifyError(
              this,
              this.getErrorMessage(error, "Unable to remove discount.")
            );
          }
        }
      });
    },

    onSelect(item) {
      this.selectedDiscount = item;
    }
  },

  created() {
    this.getDiscounts();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

.discount-code {
  align-items: center;
}
</style>
